module.exports = __webpack_public_path__ + "img/home.eef9eedd.svg";